// extracted by mini-css-extract-plugin
module.exports = {"container":"calendar-dates__container___fPpzd","week":"calendar-dates__week___rQFD7"};